var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('span',[(_vm.canViewResource)?_c('nuxt-link',{attrs:{"to":_vm.url}},[_vm._v("\n    "+_vm._s(_vm.value)+"\n  ")]):[_vm._v("\n    "+_vm._s(_vm.value)+"\n  ")]],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }